module.exports = require('./src/dat/index');



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!../index.js
 **/